export default __webpack_public_path__ + "static/media/lhd-awd-hero-mobile.d7d96ba9.jpg";